import React, { Component } from "react";
import Navbar from "../../components/Navbar.js";
import {
  alert,
  format_date,
  GET,
  toFixed,
  loading,
  BtnIcon,
  project,
  total,
  DatePicker,
  fieldSorter
} from "../../components/CustomComponent.js";
import Pagination from "@mui/material/Pagination";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";

import { saveAs } from "file-saver";
import ExcelJS from 'exceljs';
export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,
      modal_detail: false,

      search: "",
      count: 0,
      start_date: "",
      end_date: "",

      data: [],
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  processItems = (items) => {
    for (let item of items) {
      if (item.transaction_payments?.length > 0) {
        const tp = item.transaction_payments;
        const sumIf = (flag, field) => tp.every(p => !p[flag]) ? 0 : total(tp.filter(p => p[flag]), field);
        item.water_bill = sumIf("s_water_bill", "water_bill");
        item.waste_cost = sumIf("s_waste_cost", "waste_cost");
        item.reduce_debt = sumIf("s_reduce_debt", "reduce_debt");
        item.other_income = sumIf("s_other_income", "other_income");
        item.meter_connect_cost = sumIf("s_meter_connect_cost", "meter_connect_cost");
        item.fire_cost = sumIf("s_fire_cost", "fire_cost");
        item.equipment_maintenance_fee = sumIf("s_equipment_maintenance_fee", "equipment_maintenance_fee");
        item.common_expenses = sumIf("s_common_expenses", "common_expenses");
        item.cable_cost = sumIf("s_cable_cost", "cable_cost");
        item.add_debt = sumIf("s_add_debt", "add_debt");
        if (tp.every(p => !p.s_late_payment)) {
          item.total_cost_late = 0;
          item.late_payment = 0;
        } else {
          item.total_cost_late = total(tp.filter(p => p.s_late_payment), "total_cost_late");
          item.late_payment = item.total_cost_late;
        }
      } else {
        item.water_bill = item.s_water_bill ? (item.water_bill || 0) : 0;
        item.waste_cost = item.s_waste_cost ? (item.waste_cost || 0) : 0;
        item.reduce_debt = item.s_reduce_debt ? (item.reduce_debt || 0) : 0;
        item.other_income = item.s_other_income ? (item.other_income || 0) : 0;
        item.meter_connect_cost = item.s_meter_connect_cost ? (item.meter_connect_cost || 0) : 0;
        item.fire_cost = item.s_fire_cost ? (item.fire_cost || 0) : 0;
        item.equipment_maintenance_fee = item.s_equipment_maintenance_fee ? (item.equipment_maintenance_fee || 0) : 0;
        item.common_expenses = item.s_common_expenses ? (item.common_expenses || 0) : 0;
        item.cable_cost = item.s_cable_cost ? (item.cable_cost || 0) : 0;
        item.add_debt = item.s_add_debt ? (item.add_debt || 0) : 0;
        item.total_cost_late = item.s_late_payment ? (item.total_cost_late || item.late_payment || 0) : 0;
        item.late_payment = item.total_cost_late;
      }
      if (item.record_other_list?.length !== 0) {
        item.other_income = total(item.record_other_list, "cost");
      }
      item.total_amount = item.water_bill + item.waste_cost + item.other_income + item.meter_connect_cost + (item.total_cost_late || item.late_payment || 0) + item.fire_cost + item.equipment_maintenance_fee + item.common_expenses + item.cable_cost + item.add_debt - item.reduce_debt;
    }
    return items.sort((a, b) => b.iw_number.localeCompare(a.iw_number));
  };

  Get = async (page) => {
    loading(true);
    let result = await GET("api/admin/payment-history/list", {
      page,
      page_size: 20,
      data_search: this.state.search,
      start_date: this.state.start_date || "",
      end_date: this.state.end_date || "",
    });
    if (result?.status) {
      this.setState({ data: this.processItems(result.data), count: result.count },() => 
    {
      setTimeout(() => {
        loading(false);
      }, 500)
    });
    }
  };
  Print = async (data) => {
    loading(true);

    try {
      const array_cost = ["add_debt", "cable_cost", "common_expenses", "equipment_maintenance_fee", "fire_cost", "late_payment", "meter_connect_cost", "other_income", "reduce_debt", "waste_cost", "water_bill"];
      let result = await GET(`api/admin/payment-history/list`, { record_receipt_id: data.record_receipt_id });
      
      if (result?.status) {
        let data = result.data;
        const baseHeader = {
          project_name: project["project_name"],
          project_address: `เลขที่ ${project["project_address"]}\nเบอร์โทรติดต่อ ${project["phone_number"]} เลขที่ผู้เสียภาษี ${project["tax_number"]}`,
          cutomer_name: data.full_name,
          cutomer_address: data.address || data.address_number,
          number: data.iw_number,
          date: format_date(data.record_date, "dd mmmm yyyy"),
          payment: data.payment_type === 1 ? "เงินสด" : "โอนเงินเข้าบัญชีนิติฯ",
          payment_date: `${format_date(data.transfer_date || data.record_date, "dd/mm/yyyy")} เวลา ${(data.transfer_time || data.record_time)?.slice(0, 5)}`
        };

        if (data?.record_other_list?.length > 0) {
          const otherInfo = data.record_other_list[0];
          localStorage.setItem("DATA_", JSON.stringify({ ...baseHeader, title: otherInfo.title, description: otherInfo.description, cost: otherInfo.cost, total: otherInfo.cost, change_satang: 0 }));
          window.open("/doc/receipt-other", "_blank");
        } else {
          const tp = data.transaction_payments || [];
          tp.sort(fieldSorter(["water_current_month"]));
          const fst = tp.length > 0 ? tp[0] : data;

          const getP = (type) => fst?.[`s_${type}`] ? (type === "late_payment" ? (fst["total_cost_late"] ?? fst["late_payment"]) : fst[type]) : 0;
          const getT = (arr) => arr.reduce((acc, item) => acc + array_cost.reduce((sum, type) => {
            const field = type === 'late_payment' ? (item?.total_cost_late != null ? 'total_cost_late' : 'late_payment') : type;
            return sum + total([item].filter(e => e && e[`s_${type}`]), field);
          }, 0), 0);

          const water_list_price = getT(tp.slice(1));
          const total_calc = water_list_price + getT([fst]) + data.add_on_add_debt - data.add_on_reduce_debt;
  
          const lastMonth = new Date(data.last_date);
          lastMonth.setMonth(lastMonth.getMonth() - 1);
  
          localStorage.setItem("DATA_", JSON.stringify({
            ...baseHeader,
            water_current_month: data.last_date,
            water_last_month: data.brefore_last_date !== data.last_date ? data.brefore_last_date : format_date(lastMonth, "yyyy-mm-dd", "en"),
            last_gauge_number: data.last_gauge_number, current_gauge_number: data.current_gauge_number, unit_used: data.unit_used,
            water_bill: getP("water_bill"), equipment_maintenance_fee: getP("equipment_maintenance_fee"),
            waste_cost: getP("waste_cost"), common_expenses: getP("common_expenses"),
            water_list: data.transaction_payments || [], water_list_price: parseFloat(water_list_price.toFixed(2)),
            meter_connect_cost: getP("meter_connect_cost"), total_cost_late: getP("late_payment"),
            fire_cost: getP("fire_cost"), cable_cost: getP("cable_cost"), other_income: getP("other_income"),
            add_debt: getP("add_debt"), add_on_add_debt: data.add_on_add_debt,
            reduce_debt: getP("reduce_debt"), add_on_reduce_debt: data.add_on_reduce_debt,
            total: parseFloat(total_calc.toFixed(2)), change_satang: data.change_satang,
          }));
          window.open("/doc/receipt", "_blank");
        }
      } else {
        alert("","warning", "แจ้งเตือน", "ไม่มีใบแจ้งหนี้");
      }
    } catch (e) {
      console.log("e:",e)
      alert("","warning", "แจ้งเตือน", "เกิดข้อผิดพลาดในการโหลดข้อมูล");
    } finally {
      loading(false);
    }
  };

  exportExcel = async () => {
    loading(true);
    try {
      // ★ เดิมเรียก page: 0 (ดึงทั้งหมดก้อนเดียว) → ข้อมูลเยอะแล้ว request ล้ม/timeout
      //   แต่โค้ดยังสร้างไฟล์จาก [] → ได้ Excel เปล่าโดยไม่แจ้งอะไร
      //   เปลี่ยนเป็นดึงทีละหน้า (API รองรับ page + page_size) รวมครบก่อนสร้างไฟล์
      //   ถ้าหน้าไหนล้ม/ไม่ได้ข้อมูล → แจ้งเตือนและไม่บันทึกไฟล์
      const EXPORT_PAGE_SIZE = 200;
      const filter = {
        data_search: this.state.search,
        start_date: this.state.start_date || "",
        end_date: this.state.end_date || "",
      };
      let rows = [];
      let expected = 0;
      for (let page = 1; ; page++) {
        const result = await GET("api/admin/payment-history/list", { ...filter, page, page_size: EXPORT_PAGE_SIZE });
        if (!result?.status || !Array.isArray(result.data)) {
          alert("", "warning", "แจ้งเตือน", "โหลดข้อมูลสำหรับ Export ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
          return;
        }
        expected = Number(result.count) || 0;
        rows = rows.concat(result.data);
        if (result.data.length < EXPORT_PAGE_SIZE || rows.length >= expected) break;
      }
      if (rows.length === 0) {
        alert("", "warning", "แจ้งเตือน", "ไม่พบข้อมูลสำหรับ Export");
        return;
      }
      const data = this.processItems(rows);

      const wb = new ExcelJS.Workbook();
      const ws = wb.addWorksheet("รายการประวัติการชำระ");

      ws.columns = [
        { header: "เลขที่ใบเสร็จ",     key: "iw_number",                   width: 20 },
        { header: "วันที่ใบเสร็จ",       key: "record_date",                  width: 18 },
        { header: "บ้านเลขที่",          key: "address_number",               width: 15 },
        { header: "จำนวนหน่วยที่ใช้",   key: "sum_unit_used",                width: 18 },
        { header: "ค่าน้ำประปา",        key: "water_bill",                   width: 15 },
        { header: "ค่ารักษาอุปกรณ์",    key: "equipment_maintenance_fee",    width: 18 },
        { header: "ค่าส่วนกลาง",        key: "common_expenses",              width: 15 },
        { header: "ค่าขยะ",             key: "waste_cost",                   width: 12 },
        { header: "ค่าเคเบิล",          key: "cable_cost",                   width: 12 },
        { header: "ค่าเบี้ยประกัน",     key: "fire_cost",                    width: 15 },
        // ★ ค่าต่อมิเตอร์ถูกนับเข้า total_amount แต่ไม่มีคอลัมน์ → ยอดรวมไม่เท่าผลรวมคอลัมน์
        { header: "ค่าต่อมิเตอร์",      key: "meter_connect_cost",           width: 15 },
        { header: "ค่าปรับล่าช้า",      key: "late_payment",                 width: 15 },
        { header: "รายการอื่นๆ",        key: "other_income",                 width: 15 },
        { header: "เพิ่ม/ลดหนี้",       key: "add_reduce_debt",              width: 15 },
        { header: "ปรับปรุงยอดเงิน",    key: "change_satang",                width: 18 },
        { header: "รวมเป็นเงิน",        key: "total_final",                  width: 15 },
      ];

      const headerRow = ws.getRow(1);
      headerRow.height = 25;
      headerRow.eachCell((cell) => {
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF198754" } };
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
        cell.alignment = { vertical: "middle", horizontal: "center" };
      });

      const numericKeys = ["sum_unit_used", "water_bill", "equipment_maintenance_fee", "common_expenses", "waste_cost", "cable_cost", "fire_cost", "meter_connect_cost", "late_payment", "other_income", "add_reduce_debt", "change_satang", "total_final"];
      const totals = Object.fromEntries(numericKeys.map(k => [k, 0]));

      data.forEach((item) => {
        const add_reduce_debt = (item.add_debt || 0) + (item.add_on_add_debt || 0) - (item.reduce_debt || 0) - (item.add_on_reduce_debt || 0);
        // ★ total_amount (processItems) รวม add_debt - reduce_debt ไว้แล้ว — บวกเฉพาะ add_on_* กับเศษสตางค์
        //   เดิมบวก add_debt/reduce_debt ซ้ำอีกรอบ ยอดรวมเพี้ยนจากใบเสร็จ (สูตรเดียวกับ upload-data.js และใบเสร็จที่พิมพ์)
        const total_final = (item.total_amount || 0) + (item.change_satang || 0) + (item.add_on_add_debt || 0) - (item.add_on_reduce_debt || 0);

        const row = ws.addRow({
          iw_number: item.iw_number || "-",
          record_date: item.record_date ? format_date(item.record_date) : "",
          address_number: item.address_number || "",
          sum_unit_used: item.sum_unit_used || 0,
          water_bill: item.water_bill || 0,
          equipment_maintenance_fee: item.equipment_maintenance_fee || 0,
          common_expenses: item.common_expenses || 0,
          waste_cost: item.waste_cost || 0,
          cable_cost: item.cable_cost || 0,
          fire_cost: item.fire_cost || 0,
          meter_connect_cost: item.meter_connect_cost || 0,
          late_payment: item.late_payment || 0,
          other_income: item.other_income || 0,
          add_reduce_debt,
          change_satang: item.change_satang || 0,
          total_final,
        });
        row.height = 22;
        row.alignment = { vertical: "middle" };

        totals.sum_unit_used += (item.sum_unit_used || 0);
        totals.water_bill += (item.water_bill || 0);
        totals.equipment_maintenance_fee += (item.equipment_maintenance_fee || 0);
        totals.common_expenses += (item.common_expenses || 0);
        totals.waste_cost += (item.waste_cost || 0);
        totals.cable_cost += (item.cable_cost || 0);
        totals.fire_cost += (item.fire_cost || 0);
        totals.meter_connect_cost += (item.meter_connect_cost || 0);
        totals.late_payment += (item.late_payment || 0);
        totals.other_income += (item.other_income || 0);
        totals.add_reduce_debt += add_reduce_debt;
        totals.change_satang += (item.change_satang || 0);
        totals.total_final += total_final;
      });

      const totalRow = ws.addRow({ iw_number: "รวมทั้งสิ้น", record_date: "", address_number: "", ...totals });
      totalRow.height = 25;
      totalRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE8F5E9" } };
        cell.alignment = { vertical: "middle" };
      });

      const buffer = await wb.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), `รายการประวัติการชำระ.xlsx`);
    } catch (e) {
      console.error("exportExcel error:", e);
    } finally {
      loading(false);
    }
  };
  render() {
    return (
      <div className="w-100 min-vh-100">
        <Navbar
          header="Transaction History"
          page1="หน้าหลัก"
          page2="รายการประวัติการชำระ"
        />
        <div className="body px-3 pb-3 pt-0">
          <h4 className="fw-bold mb-2">รายการประวัติการชำระ</h4>
          <div className="d-flex align-items-center flex-wrap">
            <input
              type="text"
              className="form-control wpx-250 me-2 mb-2"
              placeholder="เลขที่ใบเสร็จ, เลขที่บ้าน, ชื่อ-สกุล"
              onChange={(e) => {
                this.setState({ search: e.target.value });
              }}
              value={this.state.search}
            />
            <div className="wpx-200 me-2 mb-2">
              <DatePicker
                className="form-control"
                onChange={(e) => {
                  this.setState({ start_date: e });
                }}
                value={this.state.start_date}
              />
            </div>
            <div className="wpx-200 me-2 mb-2">
              <DatePicker
                className="form-control"
                onChange={(e) => {
                  this.setState({ end_date: e });
                }}
                value={this.state.end_date}
              />
            </div>
            <div className="d-flex">
              <button
                className="btn btn-success px-4 me-2 mb-2"
                onClick={() => {
                  this.Get(1);
                }}
              >
                ค้นหา
              </button>
              <button
                className="btn btn-outline-success px-4 me-2 mb-2"
                onClick={() => {
                  window.location.reload();
                }}
              >
                ล้างค่า
              </button>
            </div>
            <button
                className="btn btn-dark px-4 ms-auto mb-2"
                onClick={() => {
                  this.exportExcel();
                }}
              >
                Export Excel
              </button>
          </div>
          <div className="card rounded border-0 overflow-hidden">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="bg-light text-secondary">
                  <tr>
                    <th className="text-nowrap">เลขที่ใบเสร็จ</th>
                    <th className="text-nowrap">วันที่ใบเสร็จ</th>
                    <th className="text-nowrap">บ้านเลขที่</th>
                    <th className="text-end text-nowrap">จำนวนหน่วยที่ใช้</th>
                    <th className="text-end text-nowrap">ค่าน้ำประปา</th>
                    <th className="text-end text-nowrap">ค่ารักษาอุปกรณ์</th>
                    <th className="text-end text-nowrap">ค่าส่วนกลาง</th>
                    <th className="text-end text-nowrap">ค่าขยะ</th>
                    <th className="text-end text-nowrap">ค่าเคเบิล</th>
                    <th className="text-end text-nowrap">ค่าเบี้ยประกัน</th>
                    {/* ★ นับเข้ายอดรวมอยู่แล้วแต่เดิมไม่แสดง */}
                    <th className="text-end text-nowrap">ค่าต่อมิเตอร์</th>
                    <th className="text-end text-nowrap">ค่าปรับล่าช้า</th>
                    <th className="text-end text-nowrap">รายการอื่นๆ</th>
                    <th className="text-end text-nowrap">เพิ่ม/ลดหนี้</th>
                    <th className="text-end text-nowrap">ปรับปรุงยอดเงิน</th>
                    <th className="text-end text-nowrap">รวมเป็นเงิน</th>
                    <th className="text-nowrap">พิมพ์ใบเสร็จ</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data?.map((item, index) => (
                    <tr key={"table_" + index}>
                      <td>{item.iw_number ? item.iw_number : "-"}</td>
                      <td>
                        {item.record_date ? format_date(item.record_date) : ""}
                      </td>
                      <td>{item.address_number || ""}</td>
                      <td className="text-end">{item.sum_unit_used || "0"}</td>
                      <td className="text-end">
                        {toFixed(item.water_bill || 0)}
                      </td>
                      <td className="text-end">
                        {toFixed(item.equipment_maintenance_fee || 0)}
                      </td>
                      <td className="text-end">
                        {toFixed(item.common_expenses || 0)}
                      </td>
                      <td className="text-end">
                        {toFixed(item.waste_cost || 0)}
                      </td>
                      <td className="text-end">
                        {toFixed(item.cable_cost || 0)}
                      </td>
                      <td className="text-end">
                        {toFixed(item.fire_cost || 0)}
                      </td>
                      <td className="text-end">
                        {toFixed(item.meter_connect_cost || 0)}
                      </td>
                      <td className="text-end">
                        {toFixed(item.late_payment || 0)}
                      </td>
                      <td className="text-end">
                        {toFixed(item.other_income || 0)}
                      </td>
                      <td className="text-end">
                        {toFixed(
                          item.add_debt +
                            item.add_on_add_debt -
                            (item.reduce_debt + item.add_on_reduce_debt),
                        ) || "0.00"}
                      </td>
                      <td className="text-end">
                        {toFixed(item.change_satang) || "0.00"}
                      </td>
                      <td className="text-end">
                        {/* ★ total_amount รวม add_debt - reduce_debt แล้ว บวกเฉพาะ add_on_* (เดิมนับซ้ำ 2 รอบ) */}
                        {toFixed(
                          (item.total_amount || 0) +
                            (item.change_satang || 0) +
                            (item.add_on_add_debt || 0) -
                            (item.add_on_reduce_debt || 0),
                        ) || "0.00"}
                      </td>
                      <td className="py-1">
                        <div className="d-flex justify-content-center">
                          <BtnIcon
                            type="print"
                            onClick={() => {
                              this.Print(item);
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-between p-3">
            <small>ทั้งหมด {this.state.count} รายการ</small>
            <Pagination
              count={Math.ceil(this.state.count / 20)}
              showFirstButton
              showLastButton
              onChange={(_, page) => {
                this.Get(page);
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}
